import { z } from "zod"
import { default as DomainLocaleCode } from "../../domain/LocaleCode.js"

/**
 * @description
 *	The schema of {@link LocaleCode} type.
 */
export const LocaleCodeSchema = z.enum(DomainLocaleCode)

/**
 * @description
 *	A locale code.
 */
export type LocaleCode = z.infer<typeof LocaleCodeSchema>
